import "./App.css";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import Navbar from "./components/Navbar";
import { useState } from "react";
import { useInView } from "react-intersection-observer";
import Projects from "./components/Projects";
import ProjectCard from "./components/ProjectCard";

function App() {
  const [activeSection, setActiveSection] = useState("home");

  // مراقبة الأقسام المختلفة
  const { ref: heroRef } = useInView({
    threshold: 0.5,
    onChange: (inView) => inView && setActiveSection("home"),
  });

  const { ref: aboutRef } = useInView({
    threshold: 0.5,
    onChange: (inView) => inView && setActiveSection("about"),
  });

  const { ref: projectsRef } = useInView({
    threshold: 0.1,
    onChange: (inView) => inView && setActiveSection("projects"),
  });

  const { ref: contactRef } = useInView({
    threshold: 0.5,
    onChange: (inView) => inView && setActiveSection("contact"),
  });

  const projectData = [
    {
      header: true,
      title: "Session App UI/UX",
      type: "UI/UX",
      paragraph: "Chat app for educational with a session system",
      skills: ["XD", "illustrator"],
      img: require("./assets/session.png"),
      button: "Behance",
      link: "https://www.behance.net/gallery/113313639/session-app",
      dir: "ltr",
    },
    {
      title: "WallPost Website",
      type: "Front-end",
      paragraph: "Landing page for a Cloud based ERP solution",
      skills: ["HTML5", "CSS3", "JS", "jquery", "bootstrap 4"],
      img: require("./assets/wallpost.png"),
      button: "Visit Website",
      link: "https://wallpostsoftware.com/global/",
      dir: "rtl",
    },
    {
      title: "Nidaa Org Website",
      type: "UI/UX",
      paragraph: "A website design for a non-profit organization",
      skills: ["Figma", "illustrator"],
      img: require("./assets/nidaa-org.png"),
      button: "Behance",
      link: "https://www.behance.net/gallery/157063923/_",
      dir: "ltr",
    },
  ];

 
  return (
    <div className="big-container bg-background_950 text-white ">
      <div className="sticky top-0 z-50">
        <Navbar activeSection={activeSection} />
      </div>
      <div ref={heroRef}>
        <HeroSection />
      </div>
      <div ref={aboutRef}>
        <About />
      </div>
      <div ref={projectsRef}>
      
        {projectData.map((project, index) => (
          <section id="projects" className="container m-auto mb-20 px-4 md:px-0">
            <div className="h-screen bg-background flex flex-col justify-center items-center gap-10 text-center">
            <ProjectCard key={index} {...project} />
            </div>
          </section>
        ))} 
      </div>
      <div ref={contactRef}>
        <Contact />
      </div>
      <Footer />
    </div>
  );
}

export default App;
